import PropTypes from 'prop-types'
// @ts-ignore no types
import type { Listing, Property } from '@adc/sdk/types'
// @ts-ignore no types
import instrument from '@adc/instrument'
import * as graph from '@adc/sdk'
import type {
  primitives,
  AuctionBlueprintOnlineReactiveArgs,
} from '@adc/blueprint'

/* eslint-disable react/no-unused-prop-types */

export const AuctionDetailsPropTypes = {
  featureFlags: PropTypes.object.isRequired,
  segment: PropTypes.object,
  listing: PropTypes.object,
  similarProperties: PropTypes.array.isRequired,
  isInTour: PropTypes.bool.isRequired,
  toggleSaveProperty: PropTypes.func,
  isFirstLookEnabled: PropTypes.bool,
  isMatchBiddingEnabled: PropTypes.bool,
}

interface HandleSavePropertyProps {
  listing: Listing
  property: Property
  saveProperty?: (args: any) => void
  source: string
}

export const handleSaveProperty = ({
  listing,
  saveProperty,
  property,
  source,
}: HandleSavePropertyProps) => {
  return saveProperty && saveProperty({ listing, property, source })
}

interface HandleRegistrationProps {
  actions: any
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
  user: primitives.AuctionUser
  actionSource?: 'make-an-offer' | 'register-to-bid'
}

export const handleRegistration = ({
  actions = {},
  listing,
  user,
  actionSource = 'register-to-bid',
}: HandleRegistrationProps) => {
  return () => {
    instrument.domainEvent({
      type: graph.enums.DomainEventTypeName.ButtonClicked,
      source: listing.urn as string,
      data: {
        element_type: 'button',
        element_id: actionSource,
        intent: 'register',
      },
    })
    const { pushOnboardingQueueItem, toggleAuthModal } = actions
    const redirectPath = `/registration/listing/${listing.listing_id}`
    const redirectToBidderRegApp = () => {
      window.location.assign(redirectPath)
    }
    if (user.logged_in) {
      redirectToBidderRegApp()
      return
    }

    pushOnboardingQueueItem([redirectToBidderRegApp])
    toggleAuthModal()
  }
}
